var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-right-root"},[_c('div',[_c('search',{staticClass:"search-comp"})],1),_c('div',[_c('user-module')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }